import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { PURGE } from 'redux-persist'
import { getWmsOrdersByDMSOrderId } from '../../../api/outboundorders/order-list'

const initialState = {
  isFetchingShipments: false,
  fetchShipmentsError: null,
  orderDetails: null,
  shipments: [],
  dmsOrderLineDetails: [],
  dmsOrderHoldDetails: [],
  selectedShipment: null,
}

export const fetchShipments = createAsyncThunk(
  'orderList/fetchShipments',
  async (args, { getState, rejectWithValue }) => {
    const state = getState()
    const request = {
      dmsOrderId: state.order.selectedOrder?.dms_order,
      orderStatus: state.order.selectedOrder?.orderStatus,
    }
    try {
      return await getWmsOrdersByDMSOrderId(request)
    } catch (exception) {
      return rejectWithValue(exception)
    }
  },
)

const orderListSlice = createSlice({
  name: 'orderList',
  initialState,
  reducers: {
    setSelectedShipment: (state, action) => {
      state.selectedShipment = action.payload
    },
    resetSelectedShipment: (state) => {
      state.selectedShipment = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchShipments.pending, (state) => {
        state.isFetchingShipments = true
        state.orderDetails = null
        state.shipments = []
        state.dmsOrderLineDetails = []
        state.dmsOrderHoldDetails = []
        state.fetchShipmentsError = null
      })
      .addCase(fetchShipments.fulfilled, (state, action) => {
        state.isFetchingShipments = false
        state.orderDetails = action.payload.data.data.orderDetails
        state.shipments = action.payload.data.data.shipments
        state.dmsOrderLineDetails = action.payload.data.data.dmsOrderLineDetails
        state.dmsOrderHoldDetails = action.payload.data.data.dmsOrderHoldDetails
      })
      .addCase(fetchShipments.rejected, (state, action) => {
        state.isFetchingShipments = false
        state.fetchShipmentsError = action.payload
      })
      /* Each time a client is selected, orders are fetched for
         either WMS or DMS so should reset the slice */
      .addCase('order/fetchOrders/pending', () => {
        return initialState
      })
      .addCase('order/searchOrders/pending', () => {
        return initialState
      })
      .addCase('orderAllocationsSummary/fetchOrderAllocationsSummary/pending', () => {
        return initialState
      })
      .addCase('orderAllocations/fetchOrderAllocations/pending', () => {
        return initialState
      })
      /* Action which gets triggered
         when running persistor.purge() */
      .addCase(PURGE, () => {
        return initialState
      })
  },
})

export const { setSelectedShipment, resetSelectedShipment } = orderListSlice.actions

export default orderListSlice.reducer
